/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Dialog,
  DialogContent,
  Button,
  TextField,
  Tooltip,
  Checkbox,
  FormControlLabel
} from '@mui/material';
import { CartEndButton, SingleOrderTypography } from '../Styled-components';
import { cashoutOrderApi } from '../../../api/orders/OrdersApi';
import { getPaymentMethodApi } from '../../../api/paymentMethod/paymentMethodApi';
import { useDispatch } from 'react-redux';
import { addSnackbar } from '../../../redux/reducers/ducks/SnackbarDuck';
import Receipt from './Receipt';
import { extractTime } from '../Shared';
import ComplimentryOrder from './ComplementryOrder';

export default function OrderDetails({
  triggerPrint,
  addPopup,
  setAddPopup,
  callFunc,
  singleOrder
}) {
  const dispatch = useDispatch();

  // handling pop Up for print
  const [print, setPrint] = useState({ isOpen: false, id: '' });

  // handling pop Up for complimentry order
  const [complimentryOrder, setComplimentryOrder] = useState({
    isOpen: false,
    id: null
  });

  const handleClose = () => {
    callFunc();
    setAddPopup({ isOpen: false });
    setGivenAmount('');
    // setPrint({ isOpen: false, id: '' });
    setPaymentMethod('');
    return () => {};
  };

  // drop down PaymentMethod

  const [method, setMethod] = useState([]);

  const paymentMethodApi = async () => {
    const res = await getPaymentMethodApi();
    setMethod(res.data);
  };
  // drop down PaymentMethod
  const [paymentMethod, setPaymentMethod] = useState();

  // const handleChangePaymentMethod = (event) => {
  //   setPaymentMethod(event.target.value);
  // };

  useEffect(() => {
    paymentMethodApi();
  }, [print.isOpen]);

  //  calculating total amount including tax
  const totalPayable = Math.round(
    singleOrder?.total +
      singleOrder?.tax +
      singleOrder?.totalCharges +
      (singleOrder?.chargesTax || 0)
  );

  // handl given amount
  const [givenAmount, setGivenAmount] = useState();
  const [validationError, setValidationError] = useState(false);

  const handleTotalChange = (event) => {
    setGivenAmount(event.target.value);
  };
  // useEffect(() => {
  //   setGivenAmount(totalPayable);
  // }, [paymentMethod]);

  const cashOutOrder = async (givenAmount, orderId) => {
    if (paymentMethod === '') {
      dispatch(
        addSnackbar({
          message: `Please Select Payment Method`,
          type: 'error'
        })
      );
    } else if (parseFloat(givenAmount) < totalPayable) {
      setValidationError(true);
    } else {
      setValidationError(false);
      const formData = {
        givenAmount: givenAmount,
        paymentMethod: paymentMethod,
        p: pra
      };
      let running = false;
      const response = await cashoutOrderApi(formData, orderId);
      if (response.status == 200) {
        handleClose();
        triggerPrint(response?.data?._id, running);
        // setPrint({ isOpen: true, id: response?.data?._id });

        dispatch(
          addSnackbar({
            message: `Order Cashed Out`,
            type: 'success'
          })
        );
      } else {
        dispatch(
          addSnackbar({
            message: response?.response?.data?.message,
            type: 'error'
          })
        );
      }
    }
  };

  const [pra, setPra] = useState(false);

  const handleChange = (event) => {
    setPra(event.target.checked);
  };

  // // disable button after order punch till API Recall
  // const [isDisabled, setIsDisabled] = useState(false);

  return (
    <div>
      <Dialog maxWidth="auto" open={addPopup.isOpen} onClose={handleClose}>
        <Box
          sx={{
            textAlign: 'center',
            width: 'auto'
            // maxWidth: '600px'
          }}>
          <Typography color="#6d1b7b" fontWeight="700">
            Order Details
          </Typography>
          <DialogContent>
            <Box textAlign="left">
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  gap: '10px'
                }}>
                <Box width="50%" borderRight="1px solid gray">
                  <SingleOrderTypography>
                    <b>Invoice: </b>
                    {singleOrder?.invoiceId}
                  </SingleOrderTypography>
                  <SingleOrderTypography>
                    <b>Order Time: </b>
                    {extractTime(singleOrder?.orderTime)}
                  </SingleOrderTypography>
                  <SingleOrderTypography>
                    <b>Accept Time: </b>
                    {extractTime(singleOrder?.accepted) || 'Not Accepted'}
                  </SingleOrderTypography>
                  <SingleOrderTypography>
                    <b>Branch: </b>
                    {singleOrder?.outlet.name}
                  </SingleOrderTypography>
                  <SingleOrderTypography>
                    <b>Customer: </b>
                    {singleOrder?.customerName}
                  </SingleOrderTypography>
                  <SingleOrderTypography>
                    <b>Contact: </b>
                    {singleOrder?.customerContact}
                  </SingleOrderTypography>
                </Box>
                <Box width="50%">
                  <SingleOrderTypography width="50%">
                    <b>Delivery Address: </b>
                    {singleOrder?.deliveryAddress}
                  </SingleOrderTypography>
                  <SingleOrderTypography>
                    <b>Accepted By: </b>
                    {singleOrder?.acceptedBy?.name}
                  </SingleOrderTypography>
                  <SingleOrderTypography>
                    <b>Order Type: </b>
                    {singleOrder?.orderType}
                  </SingleOrderTypography>
                  <SingleOrderTypography>
                    <b>
                      {singleOrder?.orderType.toLowerCase() === 'dinein'
                        ? 'Waiter: '
                        : 'Rider: '}
                    </b>
                    {singleOrder?.carrier?.name}
                  </SingleOrderTypography>

                  {singleOrder?.source && (
                    <SingleOrderTypography>
                      <b>Order Source: </b>
                      {singleOrder?.source?.name}
                    </SingleOrderTypography>
                  )}
                </Box>
              </Box>
              <TableContainer
                component={Paper}
                sx={{ minHeight: '220px', height: '200px', overflowY: 'auto' }}>
                <Table size="small">
                  <TableHead sx={{ background: '#FFA500' }}>
                    <TableRow>
                      <TableCell>Item</TableCell>
                      <TableCell>Qty</TableCell>
                      <TableCell>Discount</TableCell>
                      <TableCell>Price</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {singleOrder?.items
                      ?.filter((activeItem) => activeItem.active === true)
                      .map((item, index) => {
                        return (
                          <React.Fragment key={index}>
                            <TableRow>
                              <TableCell rowSpan={2}>
                                <p style={{ margin: 0, fontWeight: 700 }}>
                                  {item.name}
                                </p>
                                <span>
                                  <strong>Choices: </strong>
                                  <p
                                    style={{
                                      fontSize: '14px',
                                      margin: 0,
                                      display: 'inline'
                                    }}>
                                    (
                                    {item?.choices
                                      ?.reduce(
                                        (prev, current) =>
                                          (prev += current.optionName
                                            ? current.optionName +
                                              ` ${
                                                current.price
                                                  ? ` Rs. ${current.price}`
                                                  : ''
                                              }` +
                                              ','
                                            : ''),
                                        ''
                                      )
                                      .slice(0, -2)}
                                    )
                                  </p>
                                  {!item.note == '' && <b>Note: {item.note}</b>}
                                </span>
                              </TableCell>
                              <TableCell>{item.quantity}</TableCell>
                              <TableCell>{Math.round(item.discount)}</TableCell>
                              <TableCell>
                                {Math.round(item.discountedPrice)}
                              </TableCell>
                            </TableRow>
                            <TableRow>{/* <TableCell></TableCell> */}</TableRow>
                          </React.Fragment>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
              {!singleOrder?.deliveryNote == '' && (
                <b>Delivery Note:{singleOrder?.deliveryNote} </b>
              )}

              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  mt: '10px'
                }}>
                <Box>
                  <SingleOrderTypography>
                    <b>Sub-Total: </b> {Math.round(singleOrder?.subTotal)}
                  </SingleOrderTypography>
                  <SingleOrderTypography>
                    <b>Discount: </b> {singleOrder?.discount}
                  </SingleOrderTypography>
                  {singleOrder?.discountReason && (
                    <SingleOrderTypography>
                      <b>Discount Reason: </b> {singleOrder?.discountReason}
                    </SingleOrderTypography>
                  )}
                  <SingleOrderTypography>
                    <b>Charges: </b> {Math.round(singleOrder?.totalCharges)}
                  </SingleOrderTypography>
                </Box>
                <Box>
                  <SingleOrderTypography>
                    {!singleOrder?.tax == 0 && (
                      <>
                        <b>Tax: </b> {Math.round(singleOrder?.tax)}
                      </>
                    )}
                  </SingleOrderTypography>
                  <SingleOrderTypography>
                    <b>Total Payable: </b>
                    {totalPayable}
                  </SingleOrderTypography>
                </Box>
              </Box>
            </Box>
          </DialogContent>
        </Box>
        {singleOrder?.accepted ? (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
              padding: '0 10px 10px 10px'
            }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}>
              <b>Select Payment Method</b>
              <CartEndButton
                sx={{ backgroundColor: 'green' }}
                variant="contained"
                onClick={() => {
                  setComplimentryOrder({ isOpen: true, id: singleOrder._id });
                }}>
                Complimentary Order
              </CartEndButton>
            </Box>

            <Box sx={{ display: 'flex', gap: '10px', flexDirection: 'column' }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-around' }}>
                {method.map((cat, i) => (
                  <Box key={i}>
                    <Tooltip title={cat.name}>
                      <Button
                        sx={{
                          height: '50px',
                          width: '100px',
                          border:
                            paymentMethod === cat._id ? '5px solid black' : '',
                          opacity: paymentMethod === cat._id ? '0.5' : '',
                          backgroundImage:
                            cat.name.toLowerCase() == 'easypaisa'
                              ? `url('https://i0.wp.com/www.pakistangulfeconomist.com/wp-content/uploads/2020/10/EASYPAISA-Transforming-digital-financial-space-in-Pakistan.jpg?fit=1043%2C475&ssl=1')`
                              : cat.name.toLowerCase() == 'foodpanda'
                              ? `url("https://miro.medium.com/v2/resize:fit:640/0*VIJ7avn_ZpSu2lcv.png")`
                              : cat.name.toLowerCase() == 'champ'
                              ? `url('data:image/png;base64,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')`
                              : cat.name.toLowerCase() == 'mmbl'
                              ? `url('https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR1rqGcovq9Lm5m1rr2qE8ctCl-XkBD05s_mKTC1Fy2lw&s')`
                              : cat.name.toLowerCase() === 'bank'
                              ? `url('https://akm-img-a-in.tosshub.com/businesstoday/images/story/202304/full-form-of-bank-and-trivia-questions-sixteen_nine.jpg?size=1200:675')`
                              : cat.name.toLowerCase() === 'cash'
                              ? `url('data:image/jpeg;base64,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')`
                              : '',

                          backgroundRepeat: 'no-repeat',
                          backgroundSize: 'cover',
                          backgroundPosition: 'center',
                          objectFit: 'cover',
                          '&:hover': {
                            border: '5px solid black'
                          },
                          transition: 'all 0.3'
                        }}
                        variant="outlined"
                        onClick={() => {
                          setPaymentMethod(cat._id);
                        }}>
                        {/* {cat.name} */}
                      </Button>
                    </Tooltip>
                  </Box>
                ))}
              </Box>
              {/* <FormControl sx={{ width: '100%' }} size="small">
                <InputLabel>Payment Method</InputLabel>
                <Select
                  defaultValue={paymentMethod[0]}
                  value={paymentMethod.toString()}
                  label="Payment Method"
                  onChange={handleChangePaymentMethod}>
                  {method?.map((cat, index) => (
                    <MenuItem key={index} value={cat._id}>
                      {cat.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl> */}

              <Box sx={{ display: 'flex', gap: '10px' }}>
                <Box>
                  <TextField
                    autoFocus
                    size="small"
                    id="given-amount"
                    label="Given Amount"
                    type="number"
                    fullWidth
                    variant="outlined"
                    value={givenAmount}
                    onChange={handleTotalChange}
                    required
                  />

                  {validationError && (
                    <b style={{ color: 'red' }}>
                      Amount is less than Total Payable
                    </b>
                  )}
                </Box>

                <TextField
                  size="small"
                  disabled
                  label="Return to Customer"
                  type="number"
                  fullWidth
                  variant="outlined"
                  value={givenAmount === 0 ? 0 : givenAmount - totalPayable}
                />
              </Box>
              {process.env.REACT_APP_CLIENT_NAME === 'whites castle' ? (
                <FormControlLabel
                  control={<Checkbox checked={pra} onChange={handleChange} />}
                  label="Tip Amount"
                />
              ) : null}
            </Box>

            <Button
              sx={{
                opacity: givenAmount === '' ? 0.5 : 1,
                pointerEvents: givenAmount === '' ? 'none' : 'auto'
              }}
              // disabled={isDisabled}
              variant="contained"
              type="submit"
              onClick={() => {
                cashOutOrder(givenAmount, singleOrder?._id);
              }}>
              Cash Out
            </Button>
          </Box>
        ) : (
          ''
        )}
      </Dialog>
      <ComplimentryOrder
        complimentryOrder={complimentryOrder}
        setComplimentryOrder={setComplimentryOrder}
        handleClose={handleClose}
      />
      <Receipt print={print} setPrint={setPrint} />
    </div>
  );
}
